// mentionEditPlugin.js
// This plugin is intentionally empty.
//
// Mentions and hashtags use inclusive: false marks, so new text typed after them
// won't inherit the mark. Users edit mentions by deleting and retyping.
//
// The prosemirror-autocomplete plugin handles all autocomplete behavior.

import {Plugin, PluginKey} from 'prosemirror-state';

export const mentionEditPluginKey = new PluginKey('mentionEdit');

/**
 * Placeholder plugin - does nothing.
 * Kept for backwards compatibility with editorPlugins.js imports.
 */
export function createMentionEditPlugin() {
    return new Plugin({
        key: mentionEditPluginKey,
    });
}